'use strict';

/** @type {import('.')} */
module.exports = Object;



//////////////////
// WEBPACK FOOTER
// ./~/_es-object-atoms@1.1.1@es-object-atoms/index.js
// module id = Dl9w
// module chunks = 0